/**
 * Guide helper predicates — used by the guide system to check state conditions.
 */

import type { StudyState } from './study';
import type { StudyUiState } from './study';

/** Check if at least one study group exists */
export function hasAnyGroup(studyStore: StudyState): boolean {
  return studyStore.studyGroups.length > 0;
}

/** Check if any group has at least one student */
export function hasStudentsInAnyGroup(studyStore: StudyState): boolean {
  return studyStore.studyGroups.some((g) => g.students.length > 0);
}

/** Check if any group has at least one teacher */
export function hasTeachersInAnyGroup(studyStore: StudyState): boolean {
  return studyStore.studyGroups.some((g) => g.teachers.length > 0);
}

/** Check if currently in create mode */
export function isCreatingStudy(studyUiStore: StudyUiState): boolean {
  return studyUiStore.editorMode === 'create';
}

/** Check if editing study has a starting location */
export function hasEditingStudyStartLocation(studyStore: StudyState): boolean {
  return studyStore.editingStudy?.startingLocation != null;
}

/** Check if editing study has an ending location */
export function hasEditingStudyEndLocation(studyStore: StudyState): boolean {
  return studyStore.editingStudy?.endingLocation != null;
}

/** Check if editing study has been saved (has an id) */
export function isEditingStudySaved(studyStore: StudyState): boolean {
  const study = studyStore.editingStudy;
  return !!(study?.id && study.id !== '' && study.name && study.studyGroupId);
}
